import "./script";
import "./terminal";
import "./tapes";
import "./about-device";

// this is used to make parceljs bundle all scripts together.
// we can use utilize scope hoisting by this
